import { FunctionComponent, ReactNode, RefAttributes, forwardRef } from "react";

export const Tab: FunctionComponent<
  {
    title: ReactNode;
    isSelected: boolean;
    onClick?: () => void;
  } & RefAttributes<HTMLButtonElement>
> = forwardRef(function Tab({ title, isSelected, onClick }, ref) {
  return (
    <button
      ref={ref}
      className={`px-4 py-2 first-of-type:rounded-tl last-of-type:rounded-tr cursor-pointer last-of-type:border-r-0 border-r border-b -mb-[1px] ${
        isSelected
          ? "bg-white border-gray-300 border-b-white"
          : "bg-gray-100 border-gray-300 border-b-gray-300 hover:bg-gray-50"
      }`}
      onClick={onClick}
    >
      {title}
    </button>
  );
});

export const TabGroup: FunctionComponent<{ className?: string }> = ({
  children,
  className,
}) => {
  return (
    <div
      className={`flex flex-row mt-4 border-b border-gray-300 ${
        className ? className : ""
      }`}
    >
      <div className="border rounded-t border-gray-300 border-b-0 ">
        <div className="flex flex-row">{children}</div>
      </div>
    </div>
  );
};
